import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "../misc/controlInput";

export interface ControlMonthProps extends ControlTemplateProps {
    
}

export const ControlMonth: React.FC<ControlMonthProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ??  useControlStyles();
    
    return (
        <ControlInput type="month" {...ComponentProps(props)} style={{ ...styles.month ?? styles.date ?? styles.text ?? styles.input, ...props.style }} />        
    );
};